import { render, staticRenderFns } from "./StagingView.vue?vue&type=template&id=4531b630&scoped=true&"
import script from "./StagingView.vue?vue&type=script&lang=js&"
export * from "./StagingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4531b630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4531b630')) {
      api.createRecord('4531b630', component.options)
    } else {
      api.reload('4531b630', component.options)
    }
    module.hot.accept("./StagingView.vue?vue&type=template&id=4531b630&scoped=true&", function () {
      api.rerender('4531b630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/wordpress/staging/StagingView.vue"
export default component.exports